import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { usePostLikes } from "../api/getPostLikes";
import { Close } from "@mui/icons-material";
import UserTitle from "./UserTitle";

export default function PostLikes({ children, postId }) {
  const [dialogIsOpen, setDialogIsOpen] = useState();
  const postLikesQuery = usePostLikes({ postId });
  const handleOpenDialog = () => {
    setDialogIsOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogIsOpen(false);
  };

  const methods = {
    openDialog: handleOpenDialog,
  };
  return (
    <>
      {children(methods)}
      <Dialog
        open={dialogIsOpen}
        onClose={handleCloseDialog}
        maxWidth={"xs"}
        fullWidth
      >
        <DialogTitle>Curtidas</DialogTitle>
        <IconButton
          onClick={handleCloseDialog}
          sx={{ position: "absolute", top: 3, right: 3 }}
        >
          <Close />
        </IconButton>
        <DialogContent>
          {!postLikesQuery.data ? (
            <Typography>Nenhuma curtida ainda</Typography>
          ) : (
            <List sx={{ maxHeight: "450px", overflow: "auto" }}>
              {postLikesQuery.data.map((user) => {
                return (
                  <UserTitle
                    userData={{
                      studentId: user.alunoid,
                      name: user.nome,
                      pictureURL: user.foto,
                    }}
                  />
                );
              })}
            </List>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
